import React from "react";
import Details from "../components/details/Details";

const MovieDetailsPage = () => {
  return (
    <div className="movie-details-page">
      <Details />
    </div>
  );
};

export default MovieDetailsPage;
